import { useLocation } from 'react-router-dom';
import { appRoutes } from '../../app-routes';

interface ToolReturnState {
  toolReturnPath?: string;
}

export const toolReturnState = (toolReturnPath: string): ToolReturnState => ({ toolReturnPath });

export const useToolReturnPath = (fallback: string = appRoutes.AI_TOOLS): string => {
  const { state } = useLocation();
  return (state as ToolReturnState | null)?.toolReturnPath ?? fallback;
};
